define('models/TagModel',['underscore','ObjectModel','LocalStorage'],function (_,ObjectModel,LocalStorage) {
    //
    // Model Tag
    //
    var TagModelPrototype = {

        name:'TagModel',
        idAttribute:'id_tag',
        route:'apiTagModel',
        defaults:{
            filterChecked:false, // par défaut, le tag est selectionné en tant que filtre
        },
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },
        getName:function() {
          var  name = this.get('name');
            return name;
        },
        isChecked:function(){
            return this.get('filterChecked')
        },
        
    };

    var Tag = ObjectModel.extend(LocalStorage).extend(TagModelPrototype);

    return Tag;
});
